export const LABELS = {
  TITLE: 'Welcome to Sorted',
  SUBTITLE: 'Time to get your roomates together and create your first application!',
  GET_STARTED: 'Get started',
  QUICK_START: 'Quick start',
  CREATE_DRAFT: 'Create your first draft-application',
  COMPLETE_PROFILE: 'Complete profile',
  SUBMIT: 'Submit your first application',
};
